const PubSub = {
    events: {
        variantChange: 'variant-change',
        quantityUpdate: 'quantity-update',
        cartUpdate: 'cart-update',
        cartError: 'cart-error',
        optionValueSelectionChange: 'option-value-selection-change',
        productCardSwatchValueChange: 'product-card-swatch-value-change',
        onVariantPopup: 'variant-popup',
        onSubmitProductForm: 'product-form-submit',
        productCardSizeValueChange: 'product-card-size-change',
        sizeAddToCart: 'product-card-size-add-to-cart',
        onLoadPagination: 'auto-pagination-load',
        onLoadNumberPagination: 'number-pagination-load',
        onSubmitFacets: 'facets-form-submit',
        facetUpdate: 'facet-update',
        filterDrawerUpdate: 'filter-drawer-update',
        editAddress: 'edit-address',
        utilityBarScrolled: 'utility-bar-scrolled',
        themeEditorUpdate: 'theme-editor-update',
        addToCompareProduct: 'add-to-compare-product',
        removeFromCompareProduct: 'remove-from-compare-product',
        hideCompareProductCheckbox: 'hide-compare-product-checkbox',
        uncheckCompareProductCheckbox: 'uncheck-compare-product-checkbox',
        uncheckAllCompareProductCheckboxes: 'uncheck-all-compare-product-checkboxes',
        optionValueSelectionChangeInCompareProduct: 'option-value-selection-change-in-compare-product',
        optionValueSelectionChangeInBundleProduct: 'option-value-selection-change-in-bundle-product',
        onUpdatingFacetProducts: 'on-updating-facet-products',
        onUpdatedFacetProducts: 'on-updated-facet-products',
        updateCheckbox: 'update-compare-product-checkbox',
        exceedAvailableQuantity: 'exceed-available-quantity',
        cartClose: 'cart-close'
    },
    
    // subscribe to an event
    subscribe: function(eventName, callback) {
        if(!this.events[eventName]){
            this.events[eventName] = [];
        }
        this.events[eventName].push(callback);

        return () => {
            this.events[eventName] = this.events[eventName].filter(cb => cb !== callback);
        };
    },

    // publish an event
    publish: function(eventName, data) {
        if(this.events[eventName]) {
            this.events[eventName].forEach(callback => callback(data));
        }
    }
};